
export function phoneInputMask() {
	$(document).ready(function () {
		$('.get-price_input__js').mask('+7 (000)-000-00-00');
	});
}